import styled from 'styled-components';

export const BasejumpNavLogo = styled.img`
  padding: 1rem 0;
  padding-left: 1rem;
  height: 3.75rem;
  transform-origin: 0% 50%;
  transform: scale(var(--app-scale));
`;

export const VolumeControls = styled.div`
  z-index: 199;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledVolumeButton = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
`;

export const NavBarPointsContainer = styled.div`
  padding: 0.75rem 1rem;
  display: flex;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  z-index: 199;
  border: solid 1px ${({ theme }) => theme.traitBorder};
  transition: linear .2s;

  &:hover {
    border: solid 1px ${({ theme }) => theme.selection};
  }
`;

export const NavBarPointsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  justify-content: center;
`;

export const NavBarPointsLabel = styled.div`
  font-family: "BebasNeue";
  font-size: 1.25rem;
  line-height: 0.75;
  font-weight: 400;
  color: white;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 0.5rem;
  test-transform: uppercase;

  div {
    opacity: 0.4;
  }

  img {
    width: 1rem;
    height: 1rem;
    margin-top: -5%;
  }
`;

export const NavBarPointsValue = styled.div`
  font-family: "BebasNeue";
  font-size: 1.25rem;
  line-height: 0.75;
  font-weight: 400;
  color: white;
  test-transform: uppercase;
`;

export const NavBarStatsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
`;

export const NavBarStat = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: 0.5rem;
  animation: ${({ $reduced }) => $reduced ? 'pulsate 1.5s infinite' : 'none'};
`;

export const NavBarStatIcon = styled.img`
  height: 1.25rem;
  width: 1.25rem;
  object-fit: contain;
`;

export const NavBarStatValue = styled.div`
  font-family: "BebasNeue";
  font-size: 1rem;
  font-weight: 400;
  color: white;
`;

export const StyledNavBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: ${({ theme }) => theme.navHeight};
  padding: 4px ${({ theme }) => theme.frameOffset};
  align-items: center;
  background-color: ${({ theme, $isTransparent }) => $isTransparent ? 'transparent' : theme.background};

  .nav-logo-bg {
    z-index: 10;
    top: 0;
    position: absolute;
    left :0;
    height: 100%;
    width: 50vw;
    background-color: ${({ theme }) => theme.background};
  }

  .nav-logo {
    position: relative;
    height: 5.875rem;
    z-index: 199; 
    padding-top: 20px;
    padding-bottom: 20px;
    cursor: pointer;

    svg {
      width: auto;
      height: 3.75rem;
      transition: .2s ease;
      fill: white;
    }
    svg: hover {
      scale: 1.025;
      fill: ${({ theme }) => theme.selection};
    }
  }

  .nav-account-info {
    border: solid 2px black;
    background: ${({ theme }) => theme.backgroundDark};
    display: flex;
    flex-direction: row;
    justify-content: end;
    align-items: center;
  }

  .nav-account-info-address {
    padding: 0.75rem 1.25rem;
    font-family: "NeueMachina";
    font-size: 1.25rem;
    font-weight: 800;
    color: ${({ theme }) => theme.selection};
  }

  .nav-info-and-controls {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    transform-origin: right center;
    transform: scale(var(--app-scale));
    z-index: 200;
  }

  .nav-open-app {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-width: 9rem;
    img {
      padding-bottom: 0.4rem;
      width: 2rem;
    }
  }
  .nav-controls {
    position: relative;
    z-index: 199;
    padding-top: 12px;
    padding-bottom: 12px;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: end;
    gap: 1rem;
    align-items: center;
    width: ${({ theme }) => theme.hudPanelWidth};
    min-width: ${({ theme }) => theme.hudPanelWidth};
    max-width: ${({ theme }) => theme.hudPanelMaxWidth};
  }

  .nav-controls-standalone {
    justify-content: start;
  }

  .nav-avatar-selector {
    border: solid 2px ${({ theme }) => theme.borderDark};
    width: 100%;
    height: 100%;
  }

  .app-popup-background {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 199;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.3);
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    height: 3.75rem;
    padding: 12px 12px;

    .nav-logo {
      height: 3.75rem;
      padding-top: 10px;
      padding-bottom: 10px;

      svg {
        height: 2.5rem;
      }
    }

    .app-popup-background {
      margin-right: -12px;
    }
  }

`;

export const StandaloneAccountInfoHolder = styled.div`
  width: 100%;
  border: solid 2px black;
  background: ${({ theme }) => theme.backgroundDark};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const StandaloneAccountInfoAddress = styled.div`
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 6px;
  font-family: "NeueMachina";
  font-size: 1.25rem;
  font-weight: 800;
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  color: ${({ theme }) => theme.selection};
`;

export const StandaloneAccountInfoImage = styled.div`
  min-width: 3rem;
  min-height: 3rem;
  background: ${({ theme }) => theme.buttonBrightBlue};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  img {
    width: 50%;
    height: 50%;
  }
`;
